var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"help-center-host",attrs:{"aria-hidden":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }